// extracted by mini-css-extract-plugin
module.exports = {"actionsContainer":"FolderForm_actionsContainer__1bgRK"};